import { render } from "./ShareEmbed.vue?vue&type=template&id=44962836&scoped=true"
import script from "./ShareEmbed.vue?vue&type=script&lang=js"
export * from "./ShareEmbed.vue?vue&type=script&lang=js"

import "./ShareEmbed.vue?vue&type=style&index=0&id=44962836&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-44962836"

export default script